import React, { Component, createRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { showNotification } from "../../uti";
import { compressImage } from "../../utils/imageUtils";
import { uploadImageToStorage } from "../../utils/uploadImageToStorage";
import themeLarge from "../ThemeLarge";
import CustomQuillToolbar from "./customQuillToolbar";

class BlogEditor extends Component {
  constructor(props) {
    super(props);
    this.quillRef = createRef();
    // if i remove the modules, then I can't use the Quill!
    this.hiddenFileInputRef = createRef();
    this.modules = {
      toolbar: {
        container: [
          [{ font: ["Kumbh Sans"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ script: "sub" }, { script: "super" }],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ align: [] }],
          ["link", "image"],
          ["clean"],
          ["tldr"],
        ],
        handlers: {
          image: () => this.handleImageUpload(),
          tldr: () => this.insertTLDR(),
        },
      },
    };
  }

  handleImageUpload = () => {
    this.hiddenFileInputRef.current.click();
  };

  handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const compressed = await compressImage(file);
      const url = await uploadImageToStorage(compressed, "blogImages");

      const imageIndex = this.props.images.length;
      const newImages = [...this.props.images, url];

      const quill = this.quillRef.current.getEditor();
      const range = quill.getSelection(true);
      const placeholder = `[image ${imageIndex}]`;

      quill.insertText(range.index, placeholder);
      quill.setSelection(range.index + placeholder.length);

      this.props.setImages(newImages);
      showNotification(
        `Image uploaded and placeholder (image ${imageIndex}) inserted!`,
        "success",
        3000
      );
    } catch (err) {
      showNotification("Failed to upload image!", "error", 3000);
    }
  };

  insertTLDR = () => {
    const quill = this.quillRef.current.getEditor();
    const range = quill.getSelection(true);
    if (!range) return;

    const selectedText = quill.getText(range.index, range.length);

    const wrapped = `<<TLDR>> ${selectedText} <<END>>`;

    quill.deleteText(range.index, range.length);
    quill.insertText(range.index, wrapped);
    quill.setSelection(range.index + wrapped.length);
  };

  render() {
    return (
      <>
        <input
          type="file"
          accept="image/*"
          ref={this.hiddenFileInputRef}
          style={{ display: "none" }}
          onChange={this.handleImageChange}
        />
        <CustomQuillToolbar />
        <style>{`
          .ql-editor {
            font-size: ${themeLarge.fontSize.body};
            font-family: 'Kumbh Sans', sans-serif;
            min-height: 300px;
            caret-color: auto;
            cursor: url("https://img.icons8.com/pastel-glyph/32/cursor--v1.png"), auto;
          }

          .ql-editor * {
            cursor: url("https://img.icons8.com/pastel-glyph/32/cursor--v1.png"), auto;
          }

          #custom-toolbar button svg {
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }
        `}</style>
        <div className="form-group mb-3" style={{ height: "50vh" }}>
          <label
            htmlFor="content"
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.h4,
            }}
          >
            Content
          </label>
          <ReactQuill
            ref={this.quillRef}
            value={this.props.content}
            onChange={this.props.onChange}
            theme="snow"
            placeholder="Write your blog content here..."
            modules={{
              ...this.modules,
              toolbar: {
                ...this.modules.toolbar,
                container: "#custom-toolbar", // custom toolbar selector
              },
            }}
            style={{ height: "100%", background: "#fff" }}
          />
        </div>
      </>
    );
  }
}

export default BlogEditor;
